<script>
  import Hero from "./Hero.svelte";
  import Story from "./Story.svelte";
  import Gallery from "./Gallery.svelte";
  import Archive from "./Archive.svelte";
  import Thanks from "./Thanks.svelte";
  import PageFooter from "./PageFooter.svelte";
  import Lightbox from "./components/Lightbox.svelte";

  let lightboxOpen = $state(false);
  let lightboxIndex = $state(0);
  let lightboxItems = $state([]);

  function openLightbox(index) {
    lightboxIndex = index;
    lightboxOpen = true;
  }
</script>

<Hero bind:lightboxItems bind:openLightbox />
<Story bind:lightboxItems bind:openLightbox />
<Gallery bind:lightboxItems bind:openLightbox />
<Archive bind:lightboxItems bind:openLightbox />
<Thanks />
<PageFooter />

<Lightbox
  bind:isOpen={lightboxOpen}
  bind:currentIndex={lightboxIndex}
  items={lightboxItems}
/>
